import { Card } from 'antd';
import { Show, useTable } from '@refinedev/antd';
import { useList, useShow } from '@refinedev/core';
import { ReportForm } from './ReportForm';
import { ISittingSchedule } from '../../../interfaces/sitting';
import { IChild } from '../../../interfaces/child';

export const SittingScheduleShow = () => {
  const { queryResult } = useShow<ISittingSchedule>({
    meta: {
      fields: [
        {
          record: ['id'],
          user: ['id'],
        },
      ],
    },
  });
  const { isLoading, data } = queryResult;
  const { isLoading: isLoadingChildren, data: childrenData } = useList<IChild>({
    resource: 'children',
    filters: [{ field: 'userId', operator: 'eq', value: data?.data.user.id }],
    meta: {
      fields: ['id', 'name', 'gender', 'birthday', 'createdAt'],
    },
  });

  return (
    <Show>
      {isLoading || isLoadingChildren ? (
        <Card loading />
      ) : (
        <ReportForm recordId={data?.data.record?.id} childList={childrenData?.data || []} />
      )}
    </Show>
  );
};
